import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.UserCard', {
    emailLabelText: 'Email:',
    skypeLabelText: 'Skype:',
    phoneLabelText: 'Phone:',
});
